import React from 'react';
import { Button, Modal, Alert, Table, FormGroup, Radio, Row, Col, DropdownButton, MenuItem, ControlLabel, FormControl } from 'react-bootstrap';
import { goTo, FieldGroup } from '../../../GlobalTools';

const WriteReviewModal = ({
	show_write_review_modal,
	toggleWriteReviewModal,
	customMessage,
}) => (
	<div className="conten-modal" id="modal_app">
		<Modal show={show_write_review_modal} onHide={() => toggleWriteReviewModal(false)} id="modal_app2">
			<Modal.Header closeButton>
				<Modal.Title style={{textAlign: "center"}}>
					{customMessage?customMessage:"Want to join in on the conversation?"}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p className="text-center mbottom-30">Download the app now</p>
				<a className="link" href="https://play.google.com/store/apps/details?id=com.faver.faverapp" target="_blank" ><img src='/assets/img/gp-badge.png' className="center-block mbottom-20" style={{height: '60px'}} /></a>
				<a className="link" href="https://apps.apple.com/us/app/faver/id1515531187"  target="_blank" ><img src='/assets/img/appstore-badge.png' className="center-block mbottom-30" style={{height: '60px'}} /></a>
				<p onClick={() => toggleWriteReviewModal()} className="text-center mbottom-20" style={{cursor: 'pointer'}}>I prefer to continue without an account PPPP  </p>
			</Modal.Body>
		</Modal>		
	</div>
);

export default WriteReviewModal
;


// WEBPACK FOOTER //
// ./src/client/views/items/modal/WriteReviewModal.js